// extracted by mini-css-extract-plugin
export default {"mainMenu":"Menu_mainMenu__fay19","liga":"Menu_liga__-ZZJR"};